import { ACTION_TYPE, EVENT_TARGET } from "../model";
import { EventEmitter } from "../EventEmitter";

/**
 * Resolve patient event
 * @param {string} action Action type
 * @param {Object} body event data
 */
export const PATIENT_TARGET_RESOLVER = (action, body) => {
    switch (action) {
        case ACTION_TYPE.CREATE:
            EventEmitter.dispatch(EVENT_TARGET.PATIENT, null);
            break;
        case ACTION_TYPE.UPDATE:
            EventEmitter.dispatch(EVENT_TARGET.GP, body.gp);
            if (body.interest) EventEmitter.dispatch(EVENT_TARGET.Interest, body.interest);
            if (body.nextOfKin) EventEmitter.dispatch(EVENT_TARGET.kin, body.nextOfKin);
            if (body.referral) EventEmitter.dispatch(EVENT_TARGET.Referral, body.referral);
            if (body.rejection) EventEmitter.dispatch(EVENT_TARGET.Rejection, body.rejection);
            if (body.emergency_contact) EventEmitter.dispatch(EVENT_TARGET.Emergency, body.emergency_contact);
            if (body.history) EventEmitter.dispatch(EVENT_TARGET.History, body.history);
            if (body.admitted) EventEmitter.dispatch(EVENT_TARGET.Admit, body);
            EventEmitter.dispatch(EVENT_TARGET.PATIENT, null);
            break;
        case ACTION_TYPE.DELETE:
        default:
            EventEmitter.dispatch(EVENT_TARGET.PATIENT, null);
            break;
    }
};
